import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDesktopDetection } from '../../utils/get-mobile-os';
import { updateIsDesktopDependencies } from './ducks/index.js';

const addListener = (mql, callback) => {
	try {
		// Chrome & Firefox
		mql.addEventListener('change', callback);
	} catch (e1) {
		try {
			// Safari
			mql.addListener(callback);
		} catch (e2) {
			console.error(e2); // eslint-disable-line
		}
	}
};

const removeListener = (mql, callback) => {
	try {
		// Chrome & Firefox
		mql.removeEventListener('change', callback);
	} catch (e1) {
		try {
			// Safari
			mql.removeListener(callback);
		} catch (e2) {
			console.error(e2); // eslint-disable-line
		}
	}
};

export const selectBreakpoints = state => state.browser.breakpoints;

const isDesktop = isDesktopDetection();

export const useDesktopStateManager = () => {
	const dispatch = useDispatch();
	const breakpoints = useSelector(selectBreakpoints);

	const callback = useCallback(() => {
		dispatch(updateIsDesktopDependencies(isDesktop));
	}, [dispatch]);

	const setUpBPEventListeners = useCallback(() => {
		const { small, medium, large } = breakpoints;
		const mqls = [small, medium, large]
			.filter(Boolean)
			.map(bp => `(max-width: ${bp}px)`)
			.map(query => window.matchMedia(query));
		mqls.forEach(mql => addListener(mql, callback));
	}, [breakpoints, callback]);

	useEffect(() => {
		dispatch(updateIsDesktopDependencies(isDesktop));
	}, [dispatch]);

	useEffect(() => {
		const { small, medium, large } = breakpoints;
		const mqls = [small, medium, large];
		setUpBPEventListeners();
		return () => {
			mqls.forEach(mql => removeListener(mql, callback));
		};
	}, [breakpoints, callback, setUpBPEventListeners]);
	return { setUpBPEventListeners };
};

const DesktopStateManager = () => {
	useDesktopStateManager();
	return null;
};

export default DesktopStateManager;
